<template>
  <d-container
    fluid
    class="main-content-container px-4"  >
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="5"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Zamówienia</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja zamówienia</template>
          <template v-else>Dodawanie zamówienia</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="7"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <button
          v-shortkey.once="['f8']"
          @shortkey="validateForm()"
          style="display:none;"
          v-if="!disable_confirm_button && canConfirmOrder">Open</button>
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/zamowienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          :disabled="disable_confirm_button || !canConfirmOrder"
          theme="primary"
          class="mr-1"
          @click.prevent="copyOrder">
          <i class="material-icons">
            copy_all
          </i>
          Kopiuj zamówienie
        </d-button>
        <d-button
          v-if="isEdit"
          :disabled="!data.can_invoice"
          theme="info"
          class="mr-1"
          @click.prevent="payAndInvoice">
          Wystaw fakturę
        </d-button>
        <d-button
          :disabled="disable_confirm_button || !canConfirmOrder"
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">
            save
          </i>
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <d-modal
      class="crm-new-popup"
      :key="confirm_key"
      v-if="show_confirm_modal"
      @close="closeConfirmModal()"
      style="background-color: rgba(0,0,0,0.6)!important;">
      <button
        v-shortkey.once="['enter']"
        @shortkey="submitForm()"
        style="display:none;"
        v-if="show_confirm_modal && !submitted_form">
        Accept
      </button>
      <d-modal-header>
        <d-modal-title>
          <h3 class="page-title pb-3">
            Potwierdź zamówienie
          </h3>
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <h4
          class="pb-2 border-bottom align-middle"
          style="text-align: center">
          Dane zamówienia
        </h4>
        <table class="table mt-0 mb-0 full-width">
          <thead class="bg-light">
            <tr>
              <th
                scope="col"
                class="border-0">Produkt</th>
              <th
                scope="col"
                class="border-0">Zamówienie</th>
              <th
                scope="col"
                class="border-0">Ważenie</th>
              <th
                scope="col"
                class="border-0"
                v-if="false">Wakowanie</th>
              <th
                scope="col"
                class="border-0">Kwota</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-if="arr.quantity !== '' && arr.price !== '0'"
              ref="product-cost"
              v-for="(arr, index) in products_to_send"
              :key="index">
              <td
                class="align-middle"
                v-for="(product, index) in products"
                :key="index"
                v-if="product.id === arr.product_id">
                {{ product.name }}
              </td>
              <td class="align-middle">{{ arr.quantity }} <span>{{arr.product_unit !== 'KILOGRAM' ? 'szt' : 'kg' }}</span></td>
              <td class="align-middle"> <span v-if="arr.weighing_required === 1">{{ arr.weight }} <span>kg</span></span></td>
              <td
                class="align-middle"
                v-if="false">{{ arr.is_welding === 1 ? 'Tak' : 'Nie' }}</td>
              <td class="align-middle">{{ arr.price ? Number(arr.price).toFixed(2) : '0.00' }} zł</td>
            </tr>
            <tr
              v-if="arr.quantity === '' && index === '0'"
              v-for="(arr, index) in products_to_send"
              :key="index">
              <td
                colspan="5"
                class="text-center">
                Brak wprowadzonych produktów&hellip;
              </td>
            </tr>
          </tbody>
        </table>
        <div class="order-table-sum">
          <div class="label">Łącznia kwota:</div>
          <span>{{ confirm_sum ? confirm_sum.toFixed(2) : 0 }} zł</span>
        </div>
      </d-modal-body>
      <div class="standard-buttons-form">
        <d-button
          v-if="products_to_send.length < 1"
          class="mt-0 mb-4"
          :theme="'success'"
          @click.prevent="submitForm" >
          Zapisz zamówienie
        </d-button>
        <d-button
          v-if="(arr.quantity !== '' && arr.price !== '0' && index === 0) || !products_to_send"
          v-for="(arr, index) in products_to_send"
          :key="index"
          class="mt-0 mb-4"
          :class="{isLoading: form_submitting}"
          :theme="'success'"
          @click.prevent="submitForm" >
          Zapisz zamówienie
        </d-button>
      </div>
    </d-modal>
    <!-- Form -->
    <d-form>
      <d-card class="p-3">
        <d-alert
          v-if="show_backup_alert"
          show
          theme="warning"
          class="d-flex align-items-center">
          Znaleziono zapisaną kopię danych zamówienia inną niż obecny status. Czy chcesz przywrócić te dane?
          <d-button
            theme="light"
            class="ml-auto"
            @click.prevent="restoreBackup()">
            Tak, przywróć
          </d-button>
          <d-button
            v-if="data.id === 0"
            theme="danger"
            class="ml-2"
            @click.prevent="removeBackupForNewOrder()">
            Nie, odrzuć
          </d-button>
        </d-alert>

        <d-alert
          v-if="isDebtWarningVisible"
          show
          theme="danger">
          Zadłużenie klienta przekracza wartość zamówień z ostatnich 14 dni
        </d-alert>

        <validation-observer
          ref="orders-form"
          tag="form">
          <d-row>
            <d-col>
              <div class="form-group">
                <label for="delivery_date">
                  Data dostawy:
                </label>
                <validation-provider
                  rules="required"
                  name="customer_id"
                  v-slot="{ errors }">
                  <date-picker
                    v-model="data.delivery_date"
                    valueType="format"
                    class="mr-2 w-100"/>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
            <d-col>
              <div class="form-group">
                <label for="customer_id">
                  Klient:
                </label>
                <validation-provider
                  rules="required"
                  name="customer_id"
                  v-slot="{ errors }">
                  <filter-autocomplete
                    v-model="data.customer_id"
                    :key="filter_autocomplete"
                    ref="customer_selector"
                    style="width: 100%"
                    @input="updateCustomer($event)"
                    :endpoint-items="'/customers/items'"
                    :data-id="filters.customer_id"
                    :reduce="obj => obj.id"
                    :skip-input-event="skip_product_change"
                    :endpoint-item="'/customers/item/'"
                    :placeholder="isEdit ? customer.name : 'Znajdź klienta...'"/>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
            <d-col v-if="data.customer_id">
              <div class="form-group">
                <label for="shop_id">
                  Adres dostawy:
                </label>
                <validation-provider
                  rules="required"
                  name="customer_id"
                  v-slot="{ errors }">
                  <filter-suggestion
                    :key="suggestion_place"
                    v-model="data.shop_id"
                    style="width: 100%"
                    @input="updateShop($event)"
                    :endpoint-items="'/customers/shops/items'"
                    :data-id="filters.shop_id"
                    :reduce="obj => obj.id"
                    :endpoint-item="'/customers/shops/item/'"
                    :placeholder="data.shop_id !== '' ? shop_items.name : 'Znajdź adres...'"
                    :customer-id="data.customer_id"/>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
            <d-col
              v-if="data.id"
              class="d-flex">
              <d-button
                @click="downloadLabel"
                class="mt-auto mb-3 text-nowrap w-100"
                :class="{isLoading : isDownloadingLabel}"
                theme="primary"
                outline
                type="button"
                :disabled="isDownloadingLabel">
                <i
                  class="material-icons"
                  aria-hidden="true">download</i>
                Pobierz etykietę
              </d-button>
            </d-col>
          </d-row>
          <d-row
            v-if="data.customer_id && data.delivery_date && data.shop_id"
            class="mt-2 mb-2 border-bottom">
            <d-col
              cols="6"
              md="6"
              lg="7">
              <div class="form-group">
                <h4 v-if="data.delivery_date && data.customer_id">
                  Produkty
                </h4>
              </div>
            </d-col>
            <d-col
              cols="6"
              md="6"
              lg="5">
              <div
                class="form-group"
                style="text-align: right">
                <button
                  v-shortkey.once="['f4']"
                  @shortkey="addProduct()"
                  style="display:none;">Open</button>
                <d-button
                  class="text-nowrap"
                  v-if="products_to_send.length !== 0"
                  @click.prevent="addProduct"
                  @shortkey="addProduct()"
                  style="width: 50%"
                  theme="primary">
                  <i class="material-icons">add</i>
                  Dodaj produkt
                </d-button>
              </div>
            </d-col>
          </d-row>
          <d-card
            class="mt-3 w-100"
            v-if="data.customer_id && data.delivery_date && data.shop_id">
            <div>
              <d-checkbox
                class="my-3 ml-3"
                inline
                v-model="hideOrderColumnWhenWeighingRequired">
                Ukryj kolumnę "Zamówienie" dla produktów wymagających ważenia
              </d-checkbox>
            </div>

            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
                <tr>
                  <th
                    scope="col"
                    class="border-0">Produkt</th>
                  <th
                    scope="col"
                    class="border-0"
                    v-if="false">Wakowanie</th>
                  <th
                    scope="col"
                    class="border-0"
                    style="min-width: 8rem">Zamówienie</th>
                  <th
                    scope="col"
                    class="border-0"
                    style="min-width: 5rem">Ważenie</th>
                  <th
                    scope="col"
                    class="border-0">Kwota</th>
                  <th
                    scope="col"
                    class="border-0">Akcje</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  ref="product-cost"
                  v-for="(arr, index) in products_to_send"
                  :key="index"
                  @keypress.enter.prevent="addProduct()">
                  <td
                    class="align-middle width-30-rwd"
                    :key="'product-' + data.count">
                    <div
                      style="margin-top: -1px;"
                      :class="{ 'form-control': true, 'is-select': true, 'is-invalid': disable_confirm_button && !arr.product_id }"
                      :key="'select-' + data.count">
                      <v-select
                        :filterBy="filterByName"
                        :key="data.count"
                        class="productsForPrice"
                        :ref="'product-' + index"
                        :name="'product-' + index"
                        @input="updateProduct($event, index)"
                        :options="shop_items_new"
                        v-model="arr.product_id"
                        :reduce="product => product.id"
                        label="id">
                        <template
                          slot="option"
                          slot-scope="option">
                          <div
                            class="form-group"
                            :key="data.count">
                            <div
                              class="d-center drop-name"
                              :key="data.count">
                              {{ option.name ? option.name : option.product_name }}
                            </div>
                          </div>
                        </template>
                        <template
                          slot="selected-option"
                          slot-scope="option">
                          <div
                            class="selected d-center"
                            :key="data.count">
                            {{ option.name ? option.name : option.product_name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div
                      class="form-group order-description"
                      v-if="arr.show_textarea">
                      <textarea
                        class="mt-3"
                        placeholder="Wypełnij opis..."
                        v-model="arr.description">
                      </textarea>
                    </div>
                  </td>
                  <td
                    :key="'welding-' + index"
                    v-if="false">
                    <div
                      :class="{ 'form-control': true, 'is-select': true, 'is-invalid': disable_confirm_button && !arr.product_id }"
                      :key="'welding-' + index">
                      <v-select
                        :key="'product-welding-' + index"
                        class="productsForPrice"
                        :name="'product-welding-' + index"
                        :options="weldingType"
                        v-model="arr.is_welding"
                        :reduce="welding => welding.id"
                        label="id">
                        <template
                          slot="option"
                          slot-scope="option">
                          <div class="form-group">
                            <div class="d-center drop-name">
                              {{ option.name }}
                            </div>
                          </div>
                        </template>
                        <template
                          slot="selected-option"
                          slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </td>
                  <td>
                    <div :class="'order-table-point-quantity align-items-baseline'">
                      <template v-if="!hideOrderColumnWhenWeighingRequired || (hideOrderColumnWhenWeighingRequired && !arr.weighing_required)">
                        <validation-provider
                          rules="min_value:0"
                          :name="'quantity-' + arr.id + '-' + index"
                          v-slot="{ errors }">
                          <input
                            :ref="'product-quantity-' + index"
                            style="padding: 0.5rem;"
                            :class="{
                              'custom-input-new form-control': true,
                              'is-invalid': errors.length
                            }"
                            :step="1.0"
                            :min="0.0"
                            @focus="$event.target.select()"
                            placeholder="Wpisz..."
                            @input="updateQuantity(arr.quantity, index, arr.average_weight, arr.product_unit)"
                            :state="disable_confirm_button && arr.quantity === 0 && arr.weight === 0 ? 'invalid' : null"
                            type="number"
                            v-model="arr.quantity"
                            :invalid="errors.length ? true : null" />
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </validation-provider>
                        <span v-if="arr.weighing_required === 0">{{arr.product_unit !== 'KILOGRAM' ? 'szt' : 'kg' }}</span>
                        <div
                          v-if="arr.weighing_required === 1"
                          class="form-control is-select productsUnit">
                          <v-select
                            :filterBy="filterByName"
                            :key="data.count"
                            :name="'product-' + index"
                            @input="updateQuantity(arr.quantity, index, arr.average_weight, arr.product_unit)"
                            :options="unitType"
                            v-model="arr.product_unit"
                            :reduce="unit => unit.id"
                            label="id">
                            <template
                              slot="option"
                              slot-scope="option">
                              <div
                                class="form-group"
                                :key="data.count">
                                <div
                                  class="d-center drop-name"
                                  :key="data.count">
                                  {{ option.name}}
                                </div>
                              </div>
                            </template>
                            <template
                              slot="selected-option"
                              slot-scope="option">
                              <div
                                class="selected d-center"
                                :key="data.count">
                                {{ option.label}}
                              </div>
                            </template>
                          </v-select>
                        </div>
                      </template>
                    </div>
                  </td>
                  <td>
                    <div
                      class="order-table-point-weight"
                      v-if="arr.weighing_required === 1">
                      <input
                        :ref="'product-weight-' + index"
                        style="padding: 0.5rem;"
                        class="custom-input-new no-native-arrows form-control"
                        :step="1.0"
                        :min="0.0"
                        :class="{'border-orange': arr.weight === 0 || arr.weight === '0' || !arr.weight}"
                        @focus="$event.target.select()"
                        placeholder="Wpisz ważenie..."
                        @input="updateWeight(arr.weight, index)"
                        @keydown="focusDifferentProductWeight($event, index)"
                        :state="disable_confirm_button && arr.quantity === 0 && arr.weight === 0 ? 'invalid' : null"
                        type="number"
                        v-model="arr.weight" />
                      <span class="ml-1">kg</span>
                    </div>
                  </td>
                  <td class="width-150-rwd">
                    <div class="order-product-price mt-2">{{ arr.price ? parseFloat(arr.price).toFixed(2) : '0'}} <span>zł</span></div>
                  </td>
                  <td style="width: 150px">
                    <d-button
                      :title="arr.description ? 'Opis produktu' : (arr.show_textarea ? 'Zamknij opis' : 'Dodaj opis')"
                      class="order-delete-button"
                      outline
                      @click.prevent="addTextarea(index)"
                      :theme="arr.description ? 'warning' : 'primary'">
                      <span class="material-icons">mode</span>
                    </d-button>
                    <d-button
                      title="Usuń produkt"
                      class="order-delete-button ml-2"
                      outline
                      @click.prevent="removeProduct(index)"
                      theme="danger">
                      <span class="material-icons">delete</span>
                    </d-button>
                  </td>
                </tr>
                <tr v-if="products_to_send.length === 0">
                  <td
                    colspan="6"
                    class="text-center">
                    Dodaj produkt aby wyświetlić na liście&hellip;
                    <div class="form-group mt-2">
                      <d-button
                        @click.prevent="addProduct"
                        class="mt-2 text-nowrap"
                        outline
                        theme="dark">
                        <i class="material-icons text-success">add</i>
                        Dodaj pierwszy produkt
                      </d-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="form-group my-3 mx-3">
              <label for="customer-note">
                Notatka do zamówienia:
              </label>
              <validation-provider
                rules="max:160"
                name="customer-note"
                v-slot="{ errors }">
                <textarea
                  class="form-control"
                  style="max-width: 650px;"
                  placeholder="Wpisz notatkę"
                  v-model="data.customer_note"
                  :state="errors.length ? 'invalid' : null">
                </textarea>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-card>
          <d-row
            v-if="shop_items_new.length"
            class="mt-4">
            <d-col
              cols="6"
              md="7"
              lg="7">
              <div class="form-group">
                <label :for="data.containers_number">
                  Liczba pojemników:
                </label>
                <validation-provider
                  name="containers_number"
                  rules="integer"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="number"
                    v-model="data.containers_number" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
            <d-col
              cols="6"
              md="2"
              lg="2">
              <div class="order-table-sum">
                <div class="label">Liczba produktów: {{ products_to_send ? products_to_send.length : 0 }}</div>
              </div>
            </d-col>
            <d-col
              cols="12"
              md="3"
              lg="3">
              <div
                class="order-table-sum"
                id="smooth-move">
                <div class="label">Łącznie:</div>
                <span>{{ suma ? suma.toFixed(2) : '0.00' }} zł</span>
              </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col
              col
              sm="6"
              v-if="products_to_send.length !== 0"
              class="text-right text-sm-right d-flex justify-content-end align-items-end mt-5">
              <d-button
                outline
                class="text-nowrap"
                style="width: 200px"
                @click.prevent="addProduct"
                theme="primary">
                <i class="material-icons">add</i>
                Dodaj produkt
              </d-button>
            </d-col>
            <d-col
              col
              sm="6"
              class="mt-5">
              <d-button
                style="width: 200px"
                theme="success"
                class="ml-2"
                v-if="canConfirmOrder"
                @click.prevent="validateForm">
                Zapisz zamówienie
              </d-button>
            </d-col>
          </d-row>
        </validation-observer>
        <div
          v-if="!allDataLoaded"
          class="pb-3 pt-3 text-center">
          Trwa ładowanie danych&hellip;
        </div>
        <d-alert
          v-if="load_error"
          show
          theme="warning">
          Wczytywanie danych nie powiodło się. <a
            href="javascript:window.location.reload();"
          class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
        </d-alert>
        <order-copy-modal
          v-if="data.id"
          :close-modal="closeOrderCopyModal"
          :order-customer="customer"
          :order-id="data.id"
          :show-copy-modal.sync="show_order_copy_modal"
          :customer-id="filters.customer_id" />
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import api from '@/api';
import FormUtils from '@/utils/FormUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';
import FilterAutocomplete from '@/components/others/filterAutocomplete';
import FilterSuggestion from '@/components/others/filterSuggestion';
import OrderCopyModal from '@/components/forms/orders/OrderCopyModal';
import DatePicker from 'vue2-datepicker';
import Vue from 'vue';

export default {
  name: 'orders-form',
  components: {
    FilterSuggestion,
    FilterAutocomplete,
    DatePicker,
    OrderCopyModal
  },
  computed: {
    ...mapGetters([
      'getDate'
    ]),
    allDataLoaded () {
      return this.loaded;
    },
    canConfirmOrder () {
      return this.data.customer_id && this.data.delivery_date && this.data.shop_id;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    weldingType () {
      return [
        {
          name: 'TAK',
          id: 1
        },
        {
          name: 'NIE',
          id: 0
        },
      ];
    },
    unitType () {
      return [
        {
          label: 'kg',
          name: 'Kilogramy',
          id: 'KILOGRAM'
        },
        {
          label: 'szt',
          name: 'Sztuki',
          id: 'PIECE'
        },
      ];
    },
    isDebtWarningVisible () {
      if (!this.customer) {
        return false;
      }

      return Number(this.customer.dept) >= Number(this.customer.latest_14_days_orders_price);
    }
  },
  data () {
    return {
      data: {
        id: 0,
        customer_id: '',
        count: 0,
        countParam: 0,
        shop_id: '',
        delivery_date: '',
        containers_number: 0,
        is_welding: 0,
        product_id: [],
        products: [],
        quantity: [],
        weight: [],
        description: [],
        customer_note: '',
        can_invoice: false
      },
      loaded: false,
      load_error: false,
      visibleAcceptButton: false,
      show_order_copy_modal: false,
      other_values: false,
      show_confirm_modal: false,
      disable_confirm_button: false,
      form_submitting: false,
      unit_box: '',
      price_calc: [],
      price: [],
      sum: [],
      products_order: [],
      confirm_sum: 0,
      suma: 0,
      shop_items: [],
      shop_items_new: [],
      shopItemsPrices: [],
      products_to_send: [],
      products: [],
      customer: [],
      suggestion_place: 0,
      component_institutions: 0,
      filter_autocomplete: 0,
      confirm_key: 0,
      submitted_form: false,
      filters: {
        customer_id: 0,
        shop_id: 0,
      },
      show_backup_alert: false,
      skip_product_change: false,
      hideOrderColumnWhenWeighingRequired: false,
      isDownloadingLabel: false
    };
  },
  watch: {
    'suma': function (value) {
      if (value) {
        this.disable_confirm_button = false;
      }
    },
    'data.products': function (value) {
      if (value) {
        setTimeout(() => {
          this.getProductsTodo();
        }, 200);
      }
    },
    'data.customer_id': function (id) {
      this.suggestion_place += 1;
      this.loadICustomers(id);
      this.getOrderProducts(id);
    },
    'data.shop_id': function (id) {
      if (id > 0) {
        this.getShopPrices(id);
      }
    },
    'products_order': function (value) {
      this.shop_items_new = JSON.parse(JSON.stringify(value)).sort((a, b) => ((a.name > b.name) ? 1 : -1));
    },
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      if (this.getDate) {
        this.data.delivery_date = this.getDate;
      }
      if (this.hasBackup()) {
        Vue.set(this, 'show_backup_alert', true);
      }

      this.loaded = true;
    }
    this.getOrderProducts();
    this.getProducts();
    this.$bus.$on('filter-autocomplete-data-prefetched', this.disableProductsLock);
  },
  methods: {
    ...mapActions([
      'saveDate'
    ]),
    filterByName (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    closeOrderCopyModal () {
      this.show_order_copy_modal = false;
    },
    addProduct () {
      this.products_to_send.push({
        id: 0,
        product_id: 0,
        quantity: 0,
        weight: 0,
        price: 0,
        is_welding: 0,
        weighing_required: 0,
        product_unit: 'KILOGRAM',
        average_weight: 0,
        description: null,
        show_textarea: false,
        unit: 'KILOGRAM'
      });

      this.$forceUpdate();
      this.$nextTick(() => {
        this.$refs['product-' + (Number(this.products_to_send.length) - 1)][0].$el.querySelectorAll('input')[0].focus();
        setTimeout(() => {
          this.$forceUpdate();
          this.$refs['product-' + (Number(this.products_to_send.length) - 1)][0].$el.querySelectorAll('input')[0].focus();
        }, 500);
      });
    },
    updateCustomer () {
      this.suggestion_place += 1;

      if (!this.skip_product_change) {
        this.data.shop_id = '';

        setTimeout(() => {
          this.other_values = true;
          this.getOrderProducts();
        }, 200);

        setTimeout(() => {
          this.changePricesInTab();
        }, 300);
      }
    },
    updateShop (id) {
      if (id > 0) {
        this.other_values = false;
        this.getOrderProducts();
        this.getShopPrices(id);

        if (!this.skip_product_change) {
          setTimeout(() => {
            this.changePricesInTab();
          }, 300);
        }
      }
    },
    getProductsTodo () {
      this.products_to_send = [];
      this.sum = [];
      this.price_calc = [];
      const items = this.data.products;
      this.data.count = 0;
      for (let d = 0; d < items.length; d++) {
        this.products_to_send[d] = {
          id: items[d].id,
          product_id: items[d].product_id,
          quantity: Number(items[d].quantity),
          weight: items[d].weight !== null ? Number(items[d].weight) : null,
          price: items[d].product_unit === 'KILOGRAM' ? (Number((items[d].weight === null || items[d].weight === '0.00' || items[d].weight === 0.00) ? (items[d].quantity * Number(items[d].product_price)) : (items[d].weight * Number(items[d].product_price)))) :
          (Number((items[d].weight === null || items[d].weight === '0.00' || items[d].weight === 0.00 || items[d].weight === 0) ? (items[d].quantity * (Number(items[d].weighing_required === 1 ? (Number(items[d].average_weight * Number(items[d].product_price))) : Number(items[d].product_price)))) : (items[d].weight * Number(items[d].product_price)))),
          unit: items[d].product_unit,
          is_welding: items[d].is_welding,
          description: items[d].description,
          product_unit: items[d].product_unit,
          average_weight: items[d].average_weight,
          product_price: items[d].product_price,
          show_textarea: false,
          weighing_required: items[d].weighing_required
        };
        let price = [];
        price[d] = this.products_to_send[d].price;
        this.price_calc.push(Number(items[d].product_price));
        this.sum[d] = price[d];
        this.updateSum();
        this.data.count += 1;
      }
    },
    changePricesInTab () {
      const items = this.data.products;
      this.products_to_send = [];
      this.sum = [];
      this.price_calc = [];
      for (let d = 0; d < items.length; d++) {
        let productItem = [];
        productItem[d] = JSON.parse(JSON.stringify(this.shop_items_new.filter(product => product.id === items[d].product_id)[0]));
        this.products_to_send[d] = {
          id: items[d].id,
          product_id: items[d].product_id,
          quantity: Number(items[d].quantity),
          weight: Number(items[d].weight),
          price: items[d].product_unit === 'KILOGRAM' ? (Number((items[d].weight === null || items[d].weight === '0.00' || items[d].weight === 0.00) ? (items[d].quantity * Number(items[d].product_price)) : (items[d].weight * Number(items[d].product_price)))) :
          (Number((items[d].weight === null || items[d].weight === '0.00' || items[d].weight === 0.00 || items[d].weight === 0) ? (items[d].quantity * (Number(items[d].weighing_required === 1 ? (Number(items[d].average_weight * Number(items[d].product_price))) : Number(items[d].product_price)))) : (items[d].weight * Number(items[d].product_price)))),
          unit: items[d].product_unit,
          is_welding: items[d].is_welding,
          description: items[d].description,
          product_unit: items[d].product_unit,
          average_weight: items[d].average_weight,
          product_price: items[d].product_price,
          show_textarea: false,
          weighing_required: items[d].weighing_required
        };
        let price = [];
        price[d] = this.products_to_send[d].price;
        this.sum[d] = price[d];
        this.price_calc.push(Number(productItem[d].product_price));
        this.updateSum();
      }
      this.data.count += 1;
    },
    updateProduct (productID, index) {
      this.data.count += 1;
      this.products_to_send[index].price = 0;
      this.price_calc[index] = 0;
      let productItem = null;

      let filteredProducts = this.shop_items_new.filter(product => product.id === productID);
      if (filteredProducts.length) {
        productItem = JSON.parse(JSON.stringify(filteredProducts[0]));
      }

      this.$nextTick(() => {
        if (productItem) {
          this.products_to_send[index].weighing_required = productItem.weighing_required;
          this.products_to_send[index].average_weight = productItem.average_weight;
          this.products_to_send[index].default_unit = productItem.default_unit;
          this.products_to_send[index].product_price = productItem.price;
          this.price_calc[index] = Number(productItem.price);
        } else {
          this.products_to_send[index].weighing_required = 0;
          this.products_to_send[index].average_weight = 0;
          this.products_to_send[index].default_unit = 0;
          this.products_to_send[index].product_price = 0;
          this.price_calc[index] = 0;
        }

        if (this.products_to_send[index].weighing_required === 1) {
          this.products_to_send[index].product_unit = this.products_to_send[index].default_unit;
        } else {
          this.products_to_send[index].product_unit = 'PIECE';
        }
        setTimeout(() => {
          if (this.products_to_send[index].quantity === 0 || this.products_to_send[index].weight === 0) {
            this.updateWeight(this.products_to_send[index].weight, index);
            this.updateQuantity(this.products_to_send[index].quantity, index, this.products_to_send[index].average_weight, this.products_to_send[index].product_unit);
          } else {
            this.updateWeight(this.products_to_send[index].weight, index);
          }

          if (productItem) {
            this.focusNextEnabledProductInput(index);
          }
        }, 200);
      });
    },
    addTextarea (index) {
      this.products_to_send[index].show_textarea = !this.products_to_send[index].show_textarea;
      this.data.count += 1;
    },
    deleteTextarea (index) {
      this.products_to_send[index].show_textarea = false;
      this.products_to_send[index].description = null;

      this.data.count += 1;
    },
    changeValueWeight (index) {
      this.updateWeight(this.products_to_send[index].weight, index);
    },
    updateQuantity (value, index, average, unit) {
      this.data.count = 0;

      if (this.products_to_send[index].weighing_required !== 1) {
        average = 1;
      }

      if (unit !== this.unit_box) {
        this.unit_box = unit;
        this.changeValueWeight(index);
      }
      if (this.products_to_send[index].weight === null || this.products_to_send[index].weight === '' || this.products_to_send[index].weight === 0 || this.products_to_send[index].weight === '0' || !this.products_to_send[index].weight) {
        let quantity = (unit === 'PIECE' && average !== '0.00') ? (Number(value) * average) : Number(value);
        this.products_to_send[index].price = (Number(this.products_to_send[index].weighing_required === 1 ? Number(this.products_to_send[index].product_price) : Number(this.products_to_send[index].product_price))) * quantity;
        this.sum[index] = 0;
        if (this.products_to_send[index].price) {
          this.sum[index] = this.products_to_send[index].price;
        }
        this.updateSum();
        setTimeout(() => {
          this.data.count += 1;
        }, 200);
      }
    },
    updateWeight (value, index) {
      this.data.count = 0;
      if (this.products_to_send[index].weight !== 0 && value) {
        if (value === '0' && this.products_to_send[index].product_unit === 'KILOGRAM') {
          let weight = Number(this.products_to_send[index].quantity);
          this.sum[index] = 0;
          this.products_to_send[index].price = Number(this.price_calc[index]) * weight;
          if (this.products_to_send[index].price) {
            this.sum[index] = this.products_to_send[index].price;
          }
          setTimeout(() => {
            this.data.count += 1;
            this.updateSum();
          }, 200);
        }
        if (value === '0' && this.products_to_send[index].product_unit === 'PIECE') {
          let weight = Number(this.products_to_send[index].quantity) * (this.products_to_send[index].average_weight !== '0.00' ? Number(this.products_to_send[index].average_weight) : 1);
          this.sum[index] = 0;
          this.products_to_send[index].price = Number(this.price_calc[index]) * weight;
          if (this.products_to_send[index].price) {
            this.sum[index] = this.products_to_send[index].price;
          }
          setTimeout(() => {
            this.data.count += 1;
            this.updateSum();
          }, 200);
        }
        if (value !== '0') {
          let weight = Number(value);
          this.sum[index] = 0;
          this.products_to_send[index].price = Number(this.price_calc[index]) * weight;
          if (this.products_to_send[index].price) {
            this.sum[index] = this.products_to_send[index].price;
          }
          setTimeout(() => {
            this.data.count += 1;
            this.updateSum();
          }, 200);
        }
      } else {
        this.updateQuantity(this.products_to_send[index].quantity, index, this.products_to_send[index].average_weight, this.products_to_send[index].product_unit);
      }
    },
    updateSum () {
      this.data.count = 0;
      this.suma = 0;
      const allProducts = this.products_to_send;
      for (let c = 0; c < allProducts.length; c++) {
        this.suma += Number(allProducts[c].price);
        this.data.count += 1;
      }
    },
    removeProduct (index) {
      this.products_to_send.splice(index, 1);
      this.price_calc.splice(index, 1);
      this.sum.splice(index, 1);
      this.updateSum();
    },
    getProducts () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/items',
        outputKey: 'products',
        params: {
          pagination: false
        },
      });
    },
    getOrderProducts () {
      let where = {
        in_order: 1
      };
      if (this.data.customer_id !== null && this.data.customer_id && this.data.customer_id.value) {
        where.customer_id = this.data.customer_id;
      }
      if (this.data.shop_id !== null && this.data.shop_id && this.data.shop_id.value) {
        where.shop_id = this.data.shop_id;
      }
      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/items?in_order=1',
        outputKey: 'products_order',
        params: {
          pagination: false,
          in_order: 1,
          customer_id: this.data.customer_id,
          shop_id: this.data.shop_id
        },
      });
    },
    getShopPrices (id) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/shops/item/' + id,
        outputKey: 'shop_items',
        params: {
          pagination: false
        },
      });
    },
    refreshSuggestionPlace () {
      this.data.count += 1;
      this.suggestion_place += 1;
    },
    refreshFilterAutocomplete  () {
      this.data.count += 1;
      this.filter_autocomplete += 1;
    },
    loadICustomers (id) {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'customers/item/' + id,
        outputKey: 'customer',
        successAction: (client) => {
          if (client.shops.length === 1) {
            this.data.shop_id = client.shops[0].id;
          }
        }
      });
    },
    confirmOrder () {
      if (this.products_to_send.length > 0 && !this.products_to_send[this.products_to_send.length - 1].product_id) {
        this.products_to_send.pop();
      }
      for (let i = 0; i < this.products_to_send.length; i++) {
        if (this.products_to_send[i].product_id === 0 || (this.products_to_send[i].quantity === 0 && this.products_to_send[i].weight === 0)) {
          this.disable_confirm_button = true;
          this.show_confirm_modal = false;
          const el = document.getElementById('smooth-move');
          el.scrollIntoView({ behavior: 'smooth' });
        } else {
          this.show_confirm_modal = true;
          this.disable_confirm_button = false;
        }
      }
      for (let j = 0; j < this.sum.length; j++) {
        this.confirm_sum += this.sum[j];
      }

      if (this.products_to_send.length <= 0) {
        this.submitForm();
      } else {
        this.show_confirm_modal = true;
      }
    },
    copyOrder () {
      this.show_order_copy_modal = true;
    },
    closeConfirmModal () {
      this.confirm_key += 1;
      this.confirm_sum = null;
      this.show_confirm_modal = false;
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/orders/item/',
        instanceFields: ['id', 'customer_id', 'shop_id', 'delivery_date', 'quantity', 'weight', 'products', 'containers_number', 'count', 'description', 'customer_note', 'can_invoice'],
        booleanFields: ['can_invoice'],
        loadedKey: 'loaded',
        successAction: () => {
          this.saveDate(this.data.delivery_date);
          if (this.hasBackup()) {
            Vue.set(this, 'show_backup_alert', true);
          }
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['orders-form'], this.confirmOrder, this.failureForm);
    },
    failureForm (msg) {
      console.error(msg);
    },
    submitForm () {
      let formDataToSend = {
        customer_id: this.data.customer_id,
        shop_id: this.data.shop_id,
        delivery_date: this.data.delivery_date,
        supplier_id: 0,
        containers_number: this.data.containers_number,
        products: this.products_to_send,
        customer_note: this.data.customer_note
      };
      let endpointUrl = this.isEdit ? '/orders/update/' + this.id : '/orders/store';
      this.saveStateBackup();

      this.submitted_form = true;
      this.form_submitting = true;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano zamówienie',
        successText: 'Wybrane zamówienie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja zamówienia nie powiodła się. Spróbuj ponownie.',
        timer: 2000,
        successAction: () => {
          this.saveDate(this.data.delivery_date);
          this.removeStateBackup(this.data.id);
          this.$router.push('/zamowienia');
        },
        failureAction: () => {
          this.submitted_form = false;
          this.form_submitting = false;
        }
      });
    },
    hasBackup () {
      return !!localStorage.getItem('wedliny-crm-order-module-' + this.data.id);
    },
    saveStateBackup () {
      let stateToSave = JSON.stringify({
        customer_id: this.data.customer_id,
        shop_id: this.data.shop_id,
        delivery_date: this.data.delivery_date,
        containers_number: this.data.containers_number,
        products: this.products_to_send
      });

      localStorage.setItem('wedliny-crm-order-module-' + this.data.id, stateToSave);
      this.updateBackupsDB(this.data.id, +new Date());
      this.cleanUpBackups();
    },
    restoreBackup () {
      let backup = localStorage.getItem('wedliny-crm-order-module-' + this.data.id);
      backup = JSON.parse(backup);
      Vue.set(this, 'skip_product_change', true);

      Vue.nextTick(() => {
        Vue.set(this.filters, 'customer_id', backup.customer_id);
        Vue.set(this.filters, 'shop_id', backup.shop_id);
        Vue.set(this.data, 'customer_id', backup.customer_id);
        this.$refs['customer_selector'].prefetchData(backup.customer_id);
        Vue.set(this.data, 'shop_id', backup.shop_id);
        Vue.set(this.data, 'delivery_date', backup.delivery_date);
        Vue.set(this.data, 'containers_number', backup.containers_number);
        Vue.set(this, 'products_to_send', JSON.parse(JSON.stringify(backup.products)));
        this.show_backup_alert = false;

        for (let i = 0; i < backup.products.length; i++) {
          let price = backup.products[i].price;
          this.price_calc.push(Number(backup.products[i].product_price));
          this.sum[i] = price;
        }

        this.removeStateBackup(this.data.id);
      });
    },
    removeStateBackup (orderID) {
      localStorage.removeItem('wedliny-crm-order-module-' + parseInt(orderID, 10));

      let db = localStorage.getItem('wedliny-crm-order-module-db');

      if (db) {
        db = JSON.parse(db);
        let dbKeys = Object.keys(db);

        for (let i = 0; i < dbKeys.length; i++) {
          if (db[dbKeys[i]] === orderID) {
            delete db[dbKeys[i]];
          }
        }

        localStorage.setItem('wedliny-crm-order-module-db', JSON.stringify(db));
      }
    },
    updateBackupsDB (orderID, timestamp) {
      let db = localStorage.getItem('wedliny-crm-order-module-db');

      if (db) {
        db = JSON.parse(db);
        let dbKeys = Object.keys(db);

        for (let i = 0; i < dbKeys.length; i++) {
          if (db[dbKeys[i]] === orderID) {
            delete db[dbKeys[i]];
          }
        }

        db[timestamp] = orderID;
        localStorage.setItem('wedliny-crm-order-module-db', JSON.stringify(db));
      } else {
        localStorage.setItem('wedliny-crm-order-module-db', JSON.stringify({ [timestamp]: orderID }));
      }
    },
    cleanUpBackups () {
      let db = localStorage.getItem('wedliny-crm-order-module-db');
      const HISTORY_LENGTH = 50;

      if (!db) {
        return;
      }

      db = JSON.parse(db);
      let items = Object.keys(db);

      if (items.length > HISTORY_LENGTH) {
        items.sort().reverse();

        for (let i = HISTORY_LENGTH; i < items.length; i++) {
          let orderID = db[items[i]];
          localStorage.removeItem('wedliny-crm-order-module-' + parseInt(orderID, 10));
          delete db[items[i]];
        }

        localStorage.setItem('wedliny-crm-order-module-db', JSON.stringify(db));
      }
    },
    removeBackupForNewOrder () {
      this.removeStateBackup(0);
      this.show_backup_alert = false;
    },
    disableProductsLock (value) {
      if (value) {
        this.skip_product_change = false;
      }
    },
    focusNextEnabledProductInput (index) {
      this.$nextTick(() => {
        if (this.$refs['product-quantity-' + index]) {
          let quantityInput = this.$refs['product-quantity-' + index][0];

          if (quantityInput && !quantityInput.disabled) {
            quantityInput.focus();
            return;
          }
        }

        this.focusProductWeightInput(index);
      });
    },
    focusProductWeightInput (index) {
      if (this.$refs['product-weight-' + index]) {
        let weightInput = this.$refs['product-weight-' + index][0];
        if (weightInput && !weightInput.disabled) {
          weightInput.focus();
        }
      }
    },
    findClosesPrevProductWeightInputIndex (index) {
      let productWeightRefs = Object.keys(this.$refs).filter(item => this.$refs[item][0] && item.startsWith('product-weight-'));

      if (!productWeightRefs.length) {
        return null;
      }

      let smallerIndexes = productWeightRefs.map(item => item.split('-').pop()).filter(item => item < index);

      return Math.max(...smallerIndexes);
    },
    findClosesNextProductWeightInputIndex (index) {
      let productWeightRefs = Object.keys(this.$refs).filter(item => this.$refs[item][0] && item.startsWith('product-weight-'));

      if (!productWeightRefs.length) {
        return null;
      }

      let biggerIndexes = productWeightRefs.map(item => item.split('-').pop()).filter(item => item > index);

      return Math.min(...biggerIndexes);
    },
    focusDifferentProductWeight (e, index) {
      let newIndex = null;
      switch (e.keyCode) {
        case 38:
          e.preventDefault();
          newIndex = this.findClosesPrevProductWeightInputIndex(index);
          this.focusProductWeightInput(newIndex);
          break;
        case 40:
          e.preventDefault();
          newIndex = this.findClosesNextProductWeightInputIndex(index);
          this.focusProductWeightInput(newIndex);
          break;
        default:
          break;
      }
    },
    payAndInvoice () {
      this.invoice_submitting = true;

      Vue.swal({
        title: 'Wymagane potwierdzenie',
        text: 'Czy na pewno chcesz wystawić fakturę do zamówienia?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Tak, wystaw',
        cancelButtonText: 'Anuluj'
      }).then((result) => {
        if (!result.value) {
          this.invoice_submitting = false;
          return;
        }
        FormUtils.submit(this, {
          endpoint: '/orders/invoice/' + this.data.id,
          successTitle: 'Wystawiono fakturę',
          successText: 'Faktura do zamówienia została wystawiona',
          errorTitle: 'Wystąpił błąd',
          errorText: 'Nie udało się wystawić faktury do zamówienia. Spróbuj ponownie.',
          timer: 2000,
          successAction: () => {
            this.invoice_submitting = false;
            this.loadItemData();
          },
          failureAction: () => {
            this.invoice_submitting = false;
          }
        });
      });
    },
    downloadLabel () {
      this.isDownloadingLabel = true;
      let date = CalendarUtils.formatDateForPHP(new Date());
      let filename = `etykieta-${this.customer.name}-${date}`;
      filename = filename.replaceAll(' ', '-');

      axios({
        url: `${api}orders/get-label/${this.data.id}`,
        method: 'POST',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.isDownloadingLabel = false;
      });
      setTimeout(() => {
        this.isDownloadingLabel = false;
      }, 2000);
    },
  },
  beforeDestroy () {
    this.$bus.$off('filter-autocomplete-data-prefetched', this.disableProductsLock);
  }
};
</script>
<style lang="scss" scoped>
  table.table{
    input, .selected{
      padding: 0.5rem;
      font-size: .9rem;
      line-height: 1.3;
      font-weight: 500;
    }
  }
</style>
<style lang="scss">
.table td > div {
  padding-bottom: .5rem;
  padding-top: .5rem;
}
.user-status-dropdown {
  margin-left: 2rem;
  border-radius: 20px;
  .dropdown-toggle {
    padding: 0.5rem 1.7rem;
  }
  .accept, .blocked {
    min-width: 8rem !important;
  }
}
.mx-input {
  border: 1px solid rgba(60,60,60,.15);
}
.order-table-point, .order-table-point-quantity  {
  display: flex;
    span {
    margin: 0 0.5rem;
  }
}
.order-table-point-weight  {
  align-items: center;
  display: flex;
}
.order-table-sum {
  margin-top: 1.2rem;
  width: 100%;
  justify-content: flex-end;
  display: flex;
  .label {
    font-weight: 700;
    margin-top: 1rem;
  }
  span {
    color: #17c671;
    margin-left: 1rem;
    font-weight: 100;
    font-size: 2rem;
    white-space: nowrap;
  }
}
.productsForPrice{
  max-width: none;
  width: 100%;
}
.order-button-description {
  border-radius: 20px;
  margin-top: 0.5rem;
}
.order-description {
  margin: 0;
}
.productsUnit {
  max-width: 3.5rem;
  width: 100%;
  border-radius: 3px;
  margin-left: 5px;
  min-width: 80px;

  .vs__clear {
    display: none;
  }
}
textarea {
  width: 100%;
  border: 1px solid var(--form-border-color);
  border-radius: 5px;
  min-height: 4rem;
  outline: none;
  margin-bottom: -4px;
  margin-top: 1px;
  outline: none;
  &:focus {
    color: var(--text-color);
    background-color: var(--content-background);
    border-color: #007BFF;
    box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1), 0 0.156rem 0.125rem rgba(0, 0, 0, 0.06);
  }
}
  .order-product-price {
    font-weight: 600;
    color: #17c671;
    span {
      font-weight: 300;
    }
  }

  .order-column {
    max-width: 88px;
  }

  .order-column-button {
    margin-top: 29px;
    button {
      height: 38px;
      span {
        margin-left: auto !important;
        margin-right: auto !important;
        margin-top: -2px !important;
        display: block;
        margin-block: auto;
      }
    }
  }

  .order-delete-button {
    height: 38px;
    margin-top: 3px;
    span {
      margin-left: auto !important;
      margin-right: auto !important;
      margin-top: -2px !important;
      display: block;
      margin-block: auto;
      font-size: 20px;
    }
  }
.width-150-rwd {
  width: 150px;
}
.width-200-rwd {
  width: 200px;
}
.width-30-rwd {
  width: 30%;
}

.border-orange{
  border-color: orange;
}

@media only screen and (max-width: 1280px) {
  .width-150-rwd {
    width: 100px;
  }
  .width-200-rwd {
    width: 150px;
  }
  .width-30-rwd {
    width: 20%;
  }
}
</style>
